import Vue from 'vue'
import Vuex from 'vuex'

// LogRocket is disabled for production. Business data should not be transmitted to external servers.
// // store debug logging
// import LogRocket from 'logrocket'
// LogRocket.init('goelwr/survey-webapp')
// import createPlugin from 'logrocket-vuex'
// const logrocketPlugin = createPlugin(LogRocket)

// session store, only locally used
import session from './modules/session'

// main content, pulled and pushed
import surveys from './modules/surveys'
import rooms from './modules/rooms'
import items from './modules/items'
import signatures from './modules/signatures'
import resources from './modules/resources'

// resources, only pulled
import standardSurveyItems from './modules/standard-survey-items'
import roomNames from './modules/roomNames'
import modes from './modules/modes'
import fotos from './modules/fotos'
import crates from './modules/crates'
import country from './modules/country'
import vehicleType from './modules/vehicleTypes'
import legalNotes from './modules/legalNotes'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: false,
// LogRocket is disabled for production. Business data should not be transmitted to external servers.
//  plugins: [logrocketPlugin],
  modules: {
    // session
    session,
    // main content
    surveys,
    rooms,
    items,
    signatures,
    resources,
    // resources
    standardSurveyItems,
    roomNames,
    modes,
    fotos,
    crates,
    country,
    vehicleType,
    legalNotes
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js